import { addDays, addWeeks, addMonths, addYears } from 'date-fns';
import InspectionStatusFactory from './inspection_state';

const PERIOD_ADDERS = {
  days: addDays,
  weeks: addWeeks,
  months: addMonths,
  years: addYears,
};

export const nextDueDate = (from, periodCycle, periodNumber) => {
  if (!from || !periodCycle || !periodNumber) return null;
  const adder = PERIOD_ADDERS[periodCycle];
  if (!adder) return null;
  return adder(new Date(from), periodNumber);
};

class Inspection {
  PENDING_WEEKS = 2;

  constructor(inspection) {
    this.inspection = inspection;
  }

  get htmlClass() {
    return this.inspection.overdue ? 'overdue' : this.inspection.incoming ? 'incoming' : '';
  }

  get status() {
    const statuses = InspectionStatusFactory();
    if (this.inspection.canceled) return statuses.CANCELED;
    // if (this.inspection.doneAt) return statuses.DONE;
    return statuses.PENDING;
  }

  get color() {
    if (this.inspection.canceled) return 'secondary';
    if (this.inspection.overdue) return 'error';
    if (this.inspection.incoming) return 'warning';
    return 'primary';
  }

  get canceled() {
    return Boolean(this.inspection.canceled);
  }

  get done() {
    return Boolean(this.inspection.doneAt);
  }

  static create(inspection) {
    return new Inspection(inspection);
  }
}

const InspectionFactory = (inspection = null) => new Inspection(inspection);

export default InspectionFactory;
